import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/industries', label: 'Industries' },
    { path: '/insights', label: 'Insights' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' }
  ];

  const mobileNavLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/industries', label: 'Industries' },
    { path: '/government-solutions', label: 'Government Solutions' },
    { path: '/medical-procurement', label: 'Medical Procurement' },
    { path: '/real-estate-solutions', label: 'Real Estate Solutions' },
    { path: '/luxury-fashion', label: 'Luxury Fashion' },
    { path: '/automotive', label: 'Automotive' },
    { path: '/insights', label: 'Insights' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className="bg-black border-b border-[#C9A55A]/10 shadow-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-28 sm:h-36 md:h-44 lg:h-48">
          {/* Logo - Always Visible */}
          <Link to="/" className="flex-shrink-0 smooth-transition hover:opacity-80">
            <img 
              src="https://customer-assets.emergentagent.com/job_5b524126-89be-4764-a205-2c1c307aea3d/artifacts/mrnwuluu_5A3E72A5-2D0F-47D1-824C-1DD9B0FD96BF.png" 
              alt="Syndicate Consultants Inc" 
              className="h-24 sm:h-32 md:h-40 lg:h-44 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium tracking-wide smooth-transition whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-[#C9A55A]'
                    : 'text-gray-300 hover:text-[#C9A55A]'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Button 
              asChild
              className="luxury-button bg-[#C9A55A] text-black hover:bg-[#B8941F] font-semibold tracking-wide px-6 py-2 smooth-transition shadow-lg hover:shadow-[#C9A55A]/20"
            >
              <Link to="/contact">Get Started</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden text-white smooth-transition hover:text-[#C9A55A] p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black/98 backdrop-blur-md border-t border-[#C9A55A]/10">
          <div className="px-4 sm:px-6 pt-4 pb-8 space-y-4 max-w-7xl mx-auto">
            {mobileNavLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 text-base font-medium smooth-transition ${
                  location.pathname === link.path
                    ? 'text-[#C9A55A]'
                    : 'text-gray-300 hover:text-[#C9A55A]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Button 
              asChild
              className="w-full luxury-button bg-[#C9A55A] text-black hover:bg-[#B8941F] font-semibold mt-4"
            >
              <Link to="/contact">Get Started</Link>
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;